(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toolkit-landing"] && !Shopify.designMode) return;
  try {
    
/* Studio Znak Toolkit — vanilla JavaScript; native Shopify cart forms with Ajax enhancement. */
(function () {
  "use strict";

  function initToolkit(root) {
    if (!root || root.dataset.enhanced === "true") return;
    root.dataset.enhanced = "true";


    root.querySelectorAll("[data-choose-toolkit]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        const compare = root.querySelector("#sz-compare");
        if (!compare) return;
        event.preventDefault();
        compare.setAttribute("tabindex", "-1");
        compare.focus({ preventScroll: true });
        compare.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth", block: "start" });
      });
    });
    root.querySelectorAll("[data-toolkit-cart]").forEach(function (form) {
      let pending = false;
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        const button = form.querySelector("button[type=submit]");
        if (pending || button.disabled) return;
        pending = true;
        button.disabled = true;
        const label = button.textContent;
        button.textContent = "Adding…";
        form.setAttribute("aria-busy", "true");
        const message = form.querySelector("[role=status]");
        message.textContent = "";
        let retryAllowed = false;
        try {
          const data = new FormData(form);
          data.delete("return_to");
          const response = await fetch(form.action + ".js", { method: "POST", headers: { Accept: "application/json" }, body: data });
          const result = await response.json();
          if (!response.ok) {
            retryAllowed = response.status >= 400 && response.status < 500;
            throw new Error(typeof result.description === "string" ? result.description : "Could not add this item. Please check your cart.");
          }
          button.textContent = "Added";
          window.location.assign(form.dataset.cartUrl);
        } catch (error) {
          message.textContent = retryAllowed ? error.message + " " : "Could not confirm the result. Check your cart before trying again. ";
          const cartLink = document.createElement("a");
          cartLink.href = form.dataset.cartUrl;
          cartLink.textContent = "View cart";
          message.append(cartLink);
          button.textContent = label;
          button.disabled = !retryAllowed;
          pending = !retryAllowed;
        } finally {
          form.removeAttribute("aria-busy");
        }
      });
    });

    // Accessible Basics / Text tabs. Content is visible if JS is unavailable.
    const tabList = root.querySelector(".sz-panel-tabs");
    const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll("[data-panel-content]"));

    function selectPanel(selectedTab, moveFocus) {
      tabs.forEach(function (tab) {
        const active = tab === selectedTab;
        tab.setAttribute("aria-selected", String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.panelContent !== selectedTab.dataset.panel;
      });
      if (moveFocus) selectedTab.focus();
    }

    panels.forEach(function (panel) {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", "sz-tab-" + panel.dataset.panelContent);
      panel.tabIndex = 0;
    });
    selectPanel(tabs[0], false);
    tabList.hidden = false;

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () { selectPanel(tab, false); });
      tab.addEventListener("keydown", function (event) {
        let nextIndex;
        if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
        else if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        selectPanel(tabs[nextIndex], true);
      });
    });

    root.addEventListener("shopify:block:select", function (event) {
      const detail = event.target.closest("details[data-tool-block]");
      if (!detail || !root.contains(detail)) return;
      const panel = detail.closest("[data-panel-content]");
      const tab = tabs.find(function (item) { return item.dataset.panel === panel.dataset.panelContent; });
      if (tab) selectPanel(tab, false);
      detail.parentElement.querySelectorAll("details").forEach(function (item) {
        item.open = item === detail;
      });
      detail.scrollIntoView({ block: "nearest" });
    });

    // Keep feature explanations compact. Native details work without JS too.
    root.querySelectorAll(".sz-accordion").forEach(function (group) {
      group.querySelectorAll("details").forEach(function (detail) {
        detail.addEventListener("toggle", function () {
          if (!detail.open) return;
          group.querySelectorAll("details").forEach(function (other) {
            if (other !== detail) other.open = false;
          });
        });
      });
    });

    // Illustrative text animation, using the browser's Web Animations API.
    const stage = root.querySelector(".sz-moving-type");
    const modeButtons = Array.from(root.querySelectorAll("[data-animation-mode]"));
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    // Fixed bounds during a hover keep the card from chasing its own hit area.
    const hoverPointer = window.matchMedia("(hover: hover) and (pointer: fine)");
    const heroCards = Array.from(root.querySelectorAll("[data-hero-image]"));
    const heroCleanups = [];
    const heroResets = [];
    function resetHeroCard(card) {
      card.style.removeProperty("--sz-pointer-x");
      card.style.removeProperty("--sz-pointer-y");
      card.style.removeProperty("--sz-pointer-rotate");
    }
    heroCards.forEach(function (card) {
      let bounds = null;
      let frame = 0;
      let pointerX = 0;
      let pointerY = 0;
      function reset() {
        cancelAnimationFrame(frame);
        frame = 0;
        bounds = null;
        resetHeroCard(card);
      }
      function move(event) {
        if (event.pointerType !== "mouse" || !hoverPointer.matches || reducedMotion.matches) return;
        if (!card.querySelector("img")) return;
        if (!bounds) bounds = card.getBoundingClientRect();
        pointerX = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width - .5) * 2));
        pointerY = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height - .5) * 2));
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          card.style.setProperty("--sz-pointer-x", (pointerX * 6).toFixed(2) + "px");
          card.style.setProperty("--sz-pointer-y", (pointerY * 5).toFixed(2) + "px");
          card.style.setProperty("--sz-pointer-rotate", (pointerX * 1.5).toFixed(2) + "deg");
        });
      }
      heroResets.push(reset);
      card.addEventListener("pointermove", move);
      card.addEventListener("pointerleave", reset);
      card.addEventListener("pointercancel", reset);
      heroCleanups.push(function () {
        reset();
        card.removeEventListener("pointermove", move);
        card.removeEventListener("pointerleave", reset);
        card.removeEventListener("pointercancel", reset);
      });
    });
    function resetHeroMotion() {
      heroResets.forEach(function (reset) { reset(); });
    }

    let animations = [];
    let currentMode = "words";
    let currentPreset = "animator";
    let typingTimer = null;
    const presetButtons = Array.from(root.querySelectorAll("[data-demo-preset]"));
    const demoLabel = root.querySelector(".sz-demo-label");
    const animatorLabel = demoLabel.textContent;
    const defaultCaption = root.querySelector(".sz-experiment-caption").textContent;

    // Слайды приходят из блоков секции. Если их нет — работает
    // исходная фраза, зашитая в разметку.
    let slides = [];
    const slidesNode = root.querySelector("script.sz-slides");
    if (slidesNode) {
      try { slides = JSON.parse(slidesNode.textContent) || []; } catch (e) { slides = []; }
    }
    slides = slides.filter(function (s) { return s && s.phrase; });
    if (!slides.length) {
      slides = [{ phrase: "MAKE IT MOVE.", lines: "MAKE IT|MOVE.", meta: "", caption: "" }];
    }
    let slideIndex = 0;

    const metaNode = root.querySelector(".sz-slide-meta");
    const captionNode = root.querySelector(".sz-experiment-caption");
    const nextButton = root.querySelector(".sz-slide-next");

    function currentSlide() { return slides[slideIndex]; }

    function stopAnimation() {
      window.clearTimeout(typingTimer);
      typingTimer = null;
      const copy = stage.querySelector(".sz-typing-copy");
      if (copy) copy.textContent = typingText();
      const cursor = stage.querySelector(".sz-typing-cursor");
      if (cursor) cursor.classList.remove("is-blinking");
      animations.forEach(function (animation) { animation.cancel(); });
      animations = [];
    }

    function unitsFor(mode) {
      const slide = currentSlide();
      const phrase = String(slide.phrase || "");
      if (mode === "characters") {
        return typeof Intl.Segmenter === "function"
          ? Array.from(new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(phrase), function (part) { return part.segment; })
          : Array.from(phrase);
      }
      if (mode === "lines") {
        const raw = String(slide.lines || "").trim();
        const lines = raw ? raw.split("|") : [phrase];
        return lines.map(function (line) { return line.trim(); }).filter(Boolean);
      }
      return phrase.split(/\s+/).filter(Boolean);
    }

    function typingText() {
      return currentMode === "lines" ? unitsFor("lines").join("\n") : String(currentSlide().phrase);
    }

    function renderText(mode) {
      stopAnimation();
      const fragment = document.createDocumentFragment();
      unitsFor(mode).forEach(function (unit) {
        const span = document.createElement("span");
        span.textContent = unit === " " ? "\u00a0" : unit;
        span.setAttribute("aria-hidden", "true");
        fragment.appendChild(span);
      });
      stage.dataset.preset = currentPreset;
      if (currentPreset === "type-it") {
        const copy = document.createElement("span");
        copy.className = "sz-typing-copy";
        copy.setAttribute("aria-hidden", "true");
        copy.textContent = mode === "lines" ? unitsFor("lines").join("\n") : String(currentSlide().phrase);
        const cursor = document.createElement("span");
        cursor.className = "sz-typing-cursor";
        cursor.setAttribute("aria-hidden", "true");
        stage.replaceChildren(copy, cursor);
      } else {
        stage.replaceChildren(fragment);
      }
      stage.dataset.mode = mode;
      stage.setAttribute("aria-label", currentSlide().phrase);
      currentMode = mode;
      modeButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.animationMode === mode));
      });
    }

    function applySlideChrome() {
      const slide = currentSlide();
      if (metaNode) metaNode.textContent = slide.meta || "TYPE IN MOTION / " + String(slideIndex + 1).padStart(2, "0");
      demoLabel.textContent = currentPreset === "type-it" ? "TYPE IT" : animatorLabel;
      if (captionNode) captionNode.textContent = currentPreset === "type-it"
        ? "An illustration of Type It: letters, words or lines, with a blinking cursor."
        : (slide.caption || defaultCaption);
    }

    function replay() {
      stopAnimation();
      if (reducedMotion.matches) return;
      if (currentPreset === "type-it") {
        const copy = stage.querySelector(".sz-typing-copy");
        const cursor = stage.querySelector(".sz-typing-cursor");
        const units = currentMode === "words"
          ? (String(currentSlide().phrase).match(/\s*\S+\s*/g) || [])
          : unitsFor(currentMode);
        copy.textContent = "";
        cursor.classList.remove("is-blinking");
        let index = 0;
        function typeNext() {
          if (index >= units.length) {
            cursor.classList.add("is-blinking");
            typingTimer = null;
            return;
          }
          copy.textContent += (currentMode === "lines" && index > 0 ? "\n" : "") + units[index];
          index += 1;
          typingTimer = window.setTimeout(typeNext, currentMode === "characters" ? 85 : currentMode === "words" ? 300 : 600);
        }
        typingTimer = window.setTimeout(typeNext, 180);
        return;
      }
      if (typeof stage.animate !== "function") return;
      const delayStep = currentMode === "characters" ? 38 : 110;
      Array.from(stage.children).forEach(function (unit, index) {
        animations.push(unit.animate([
          { opacity: 0, transform: "translateY(0.24em)" },
          { opacity: 1, transform: "translateY(0)" }
        ], {
          duration: 650,
          delay: index * delayStep,
          easing: "cubic-bezier(0.22, 1, 0.36, 1)",
          fill: "backwards"
        }));
      });
    }

    modeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        renderText(button.dataset.animationMode);
        replay();
      });
    });
    root.querySelector(".sz-replay").addEventListener("click", replay);
    presetButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        currentPreset = button.dataset.demoPreset;
        presetButtons.forEach(function (item) {
          item.setAttribute("aria-pressed", String(item === button));
        });
        applySlideChrome();
        renderText(currentMode);
        replay();
      });
    });
    root.querySelector(".sz-demo-presets").hidden = false;

    if (nextButton) {
      if (slides.length > 1) {
        nextButton.hidden = false;
        nextButton.addEventListener("click", function () {
          slideIndex = (slideIndex + 1) % slides.length;
          applySlideChrome();
          renderText(currentMode);
          replay();
        });
      }
    }

    applySlideChrome();
    renderText(currentMode);

    root.querySelector(".sz-experiment-controls").hidden = false;
    function onMotionChange() {
      if (reducedMotion.matches) {
        stopAnimation();
        resetHeroMotion();
      }
    }
    if (typeof reducedMotion.addEventListener === "function") {
      reducedMotion.addEventListener("change", onMotionChange);
    }
    root.szCleanup = function () {
      stopAnimation();
      heroCleanups.forEach(function (cleanup) { cleanup(); });
      if (typeof reducedMotion.removeEventListener === "function") {
        reducedMotion.removeEventListener("change", onMotionChange);
      }
    };
  }

  function initAll(scope) {
    scope.querySelectorAll("#studio-znak-toolkit").forEach(initToolkit);
  }
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("#studio-znak-toolkit").forEach(function (root) {
      if (root.szCleanup) root.szCleanup();
    });
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
